const ModalTypeEnum = {
  FREE_WRITE_SIGNATURE_REMINDER: 'free-write-signature-reminder',
  FREE_WRITE_CANCEL_SIGNATURE_SURVEY: 'free-write-request-signature-cancel-survey',
  FREE_WRITE_CANCEL_SIGNATURE: 'free-write-request-signature-cancel',
  FREE_WRITE_DOCUMENT_READY: 'free-write-document-ready',
  FREE_WRITE_DOCUMENT_SHARE: 'free-write-document-ready-share',
  FREE_WRITE_DOCUMENT_SIGNATURE: 'free-write-document-ready-signature',
  FREE_WRITE_ERASER_INSTRUCTION: 'free-write-eraser-instruction',
  FREE_WRITE_EXPORT_DOCUMENT: 'free-write-export-document',
  FREE_WRITE_HIGHLIGHTER_INSTRUCTION: 'free-write-highlighter-instruction',
  FREE_WRITE_LOADING_DOCUMENT: 'free-write-loading-doc',
  FREE_WRITE_REDACT_INSTRUCTION: 'free-write-redact-instruction',
  FREE_WRITE_REQUIRE_SIGNATURE: 'free-write-require-signature',
  FREE_WRITE_SIGNATURE_MANAGER: 'free-write-signature-manager',
  FREE_WRITE_UPLOAD_LOADING: 'free-write-upload-loading',
  FREE_WRITE_UPLOAD_READY: 'free-write-upload-ready',

  MY_TEMPLATES_LIST_ZERO_STATE_ADD_RECIPIENTS: 'MY_TEMPLATES_LIST_ZERO_STATE_ADD_RECIPIENTS',
  MY_TEMPLATES_LIST_ZERO_STATE_UPLOAD: 'MY_TEMPLATES_LIST_ZERO_STATE_UPLOAD',
  MY_TEMPLATES_LIST_ZERO_STATE_UPLOAD_FREEWRITE: 'MY_TEMPLATES_LIST_ZERO_STATE_UPLOAD_FREEWRITE',
  MY_TEMPLATES_LIST_ZERO_STATE_DEMO: 'MY_TEMPLATES_LIST_ZERO_STATE_DEMO',

  SELF_SERVE_ADD_RECIPIENTS_CONFIRM: 'SELF_SERVE_ADD_RECIPIENTS_CONFIRM',
  SELF_SERVE_PUBLISH_TEMPLATE_CONFIRM: 'SELF_SERVE_PUBLISH_TEMPLATE_CONFIRM',
  SELF_SERVE_ZERO_STATE: 'SELF_SERVE_ZERO_STATE',
  SELF_SERVE_RECIPIENT_BUILDER_INTRO: 'SELF_SERVE_RECIPIENT_BUILDER_INTRO',
  SELF_SERVE_RECIPIENT_BUILDER_FINISH: 'SELF_SERVE_RECIPIENT_BUILDER_FINISH',
  SELF_SERVE_UNSHARED_SURVEY: 'SELF_SERVE_UNSHARED_SURVEY',
  UPDATE_SUBSCRIPTION_PROGRESS_READY: 'update-subscription-progress-ready',
  STATIC_FINISH_LATER: 'static-finish-later',
};

export default ModalTypeEnum;



// WEBPACK FOOTER //
// ./src-react/Modals/ModalConstants.jsx